export default __webpack_public_path__ + "972c77609cd9ebefad4c575227da7b15.webp";